<template>
  <div class="row">
      

    <div class="col-lg-12 bg-enterate" id="enterate">
        <div data-aos="fade-up" class="container">
          <div class="col-lg-12 d-flex post-date">
            <img src="/static/images/icons/calendar.svg"/>
            <h4>{{today}}</h4>
            <p>Actualizado</p>
          </div>
          <h1 class="titulo_enterate">Entérate de las soluciones <br>que ayudarán al crecimiento <br>de tu negocio</h1>
            <div class="col-lg-6 imagen_enterate" v-if="!isMobile()">
              <img src="/static/images/happy_office.png" alt="office">
          </div>
          <div class="divider-01"/>
          <SliderArticulos />
        </div>
    </div>
    
    <div class="col-lg-9 mb-3 " z style="margin-right:auto;margin-left:auto;" v-if="!isMobile()">
      <div class="container">
        <div class="bg-light text-center banner-1">
          PUBLICIDAD
        </div>
      </div>
    </div>
    <div class="bg-light text-center banner-2" v-else>
        PUBLICIDAD
    </div>

    <div class="col-lg-12" id="seccion-categorias">
      <div class="container">
        <Categorias />
      </div>
    </div>
    
    <div class="col-lg-12 mb-5" >
      <div class="container"  >
          <Articulos />
      </div>
    </div>

     <div class="col-lg-9 mb-3 " z style="margin-right:auto;margin-left:auto;" v-if="!isMobile()">
      <div class="container">
        <div class="bg-light text-center banner-2">
          PUBLICIDAD
        </div>
      </div>
    </div>
    <div class="bg-light text-center banner-2" v-else>
        PUBLICIDAD
    </div>
    
    <div class="col-lg-12" v-if="!isMobile()">
      <div data-aos="fade-left" data-aos-duration="1000" class="container">
        <div class="article-block">
          <h1>La forma fácil de calcular tu nómina</h1>
          <div class="divider-02"/>
        </div>
      </div>
    </div>
    <div class="" v-else>
      <div class="article-block">
          <h1>La forma fácil de calcular <br> la nómina</h1>
          <div class="divider-02"/>
      </div>
    </div>

    <div class="col-lg-12">
      <ArticlesFixed/>
    </div>
        
   
  </div>
</template>

<script>

import Categorias from '@/components/categorias.vue'
import AOS from 'aos'
import Articulos from '@/components/articulos.vue'
import ArticlesFixed from '@/components/articles-fixed.vue';
import SliderArticulos from '@/components/articulos-slide.vue'
import { mapActions, mapState } from "vuex";

export default {
  name: 'Blog',
  components: {
    Categorias,
    Articulos,
    SliderArticulos,
    ArticlesFixed
  },
  data() {
    return {
      today:""
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState("menu",["principal"]),
    name() {
      return this.data 
    }
  },
  methods: {
    ...mapActions("menu",["setMenu"]),
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
      getToday(){
      let meses = new Array("ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC");
      let f=new Date();

      this.today = f.getDate() +" "+ meses[f.getMonth()] +" "+ f.getFullYear();
    },
    aosRefresh(){
    setTimeout(function(){
          AOS.refresh();
          },1000);
    }

  },
  mounted () {
    this.getToday();
    this.aosRefresh();
  },
  created () {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    this.setMenu(false);
  },
}
</script>

<style scoped>

  .banner-1{
    padding:33px;
  }
  .banner-2{
    padding:50px;
  }
  
  /* boton subir
  */
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  .post-date h4{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 15px;

    margin:auto 0 auto 5px;
    color: #828282;  
  }

  .post-date p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin:auto 0 auto 25px;
    color: #BDBDBD;
  }

  h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140.62%;
    color: #1E2245;
    text-align: left;
    padding-top:40px;
    padding-bottom: 40px;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 50px auto 90px auto;
  }

  /**Estilo beneficios seccion */

  .bg-enterate {
    background: url("/static/images/bg_azul_categoria.svg") repeat-x;
  }

  .titulo_enterate {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-weight: normal;
    font-size: 50px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    padding-top:130px;
  }

  .imagen_enterate {
    margin-right: auto;
    margin-left: auto;
    margin-top:-50px;
  }

  .imagen_enterate img {
    width: 100%;
  }

  
  .titulo_articulos {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    align-items: center;
    text-align: center;

    color: #1E2245;
    padding-bottom: 40px;
    margin-top:20px;
  }

  .texto_articulos {
    font-family: Muli;
    font-style: normal;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.2px;color: #1E2245;
    padding-bottom:40px;
  }

  .testimonio{
      padding-top:205px ;
      padding-bottom:195px;
  }
  .title-testimonio{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #1E2245;
  }

  .text-testimonio{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 19px;
    text-align: center;
    color: #1E2245;
    margin-bottom:30px;
  }

  .article-block{
      background-color: #1E2245;
      color:#fff;
      text-align: center;
      padding: 50px;
      width: 100%;
  }

  .article-block p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }

  .article-block h1{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 50px;
    margin-bottom:50px;
    margin-top:30px;
  }

  .article-block a{
      color:#fff;
  }
  .divider-02 {
    height: 5px;
    width: 20%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 10px;
  }

  .card-article{
    width: 49%;
    background: #FFFFFF;
    box-shadow: 1px 3px 5px 1px rgba(107, 127, 153, 0.2);
    border-radius: 15px;
    padding: 40px 78px 40px 78px;
    text-align: justify;
    text-decoration: none;
   
  }

  .card-article p{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #2DB9D1;
    text-decoration: none;
  }

  .card-article h1{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 42px;
    margin-bottom:60px;
    color: #1E2245;
  }

  .card-article h1:hover{
    text-decoration: underline;
  }

  .card-article h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    color: #828282;
  }

  @media(max-width: 768px){

    .banner-1{
      margin-top:20px;
      width: 100%;
    }
    .banner-2{
      width: 100%;
    }

    .post-date h4{
      font-family: Muli;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 15px;

      margin:auto 0 auto 5px;
      color: #828282;  
    }

    .post-date p{
      font-family: Muli;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      margin:auto 0 auto 25px;
      color: #BDBDBD;
    }

    .titulo_enterate {
      font-weight: 800px;
      font-size: 24px;
      line-height: 40px;
      align-items: center;
      text-align: center;
      letter-spacing: 0.2px;
      color: #1E2245;
      padding-top:100px;
      padding-bottom: 0px;
    }

    .divider-01 {
      margin: 60px auto 80px auto;
      width: 70%;
    }
    
    .article-block{
      text-align: left;
      padding: 50px;
      width: 100%;
      margin-left:0px;
      margin-right: 0px;
  }

  .article-block h1{
    width: 80%;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 0px;
  }

  .divider-02 {
    height: 5px;
    width: 40%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 25px 0px 50px 0px;
  }

  .card-article{
    width: 100%;
    box-shadow: 0px 0px 0px 0px rgba(107, 127, 153, 0.2);
    border-radius: 0px;
    padding: 20px;
   
  }

  .card-article a{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: #2DB9D1;
  }

  .card-article h1{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 42px;
    margin-bottom:0px;
    color: #1E2245;
  }

  .btnDemo {
    font-family: Muli-Bold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        color: #FFF ;
        background: #2DB9D1;
        border-color: #2DB9D1;
            width: 100%; 
            margin-bottom: 25px;
            padding-bottom: 13px;
            padding-top:13px;
            border-radius: 14px;
        }

         .titulo_precio {
        font-family: Muli;
        font-style: normal;
        font-weight: 800;
        font-size: 26px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2245;
        margin-bottom:30px;
        margin-top:80px;
        }

  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>
